module.exports = __webpack_public_path__ + "media/images/blup-9c3b1aa1b8acf0a2083aff1a138297e4.png";